import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AuthRoutingModule} from './auth-routing.module';
import {LoginComponent} from './login/login.component';
import {CaptchaModule} from 'primeng/primeng';

@NgModule({
  imports: [CommonModule, FormsModule, AuthRoutingModule, CaptchaModule],
  exports: [LoginComponent],
  declarations: [LoginComponent],
})
export class AuthModule {}
